// @ts-nocheck
import { filter, length, object_map } from "@pdfking/rfunc"
import {
  Identity,
  Items,
  Keys,
  Partial,
  SafePromise,
  Sleep,
  UnixTime,
  Values,
} from "@pdfking/tfunc"
import * as tracker_names from "@pdfking/translations/enum/trackers"
import { RegisterCallbacks } from "../actions/pdfengine/RegisterCallback"
import fire_event from "../utils/fire_event"
import make_translations from "../utils/make_translations"
import render_string from "../utils/render_string"
import uuid from "../utils/uuid"
import delete_property from "../vue/3/delete_property"
import virtual from "../vue/3/virtual"

export default virtual({
  computed: {
    is_loading() {
      return length(this.trackers) > 0
    },
    trackers() {
      const blank = () => ({
        done: 0,
        get is_finished() {
          return this.task_total - this.task_done == 0
        },
        task_done: 0,
        task_total: 0,
        total: 0,
      })
      const trackers = object_map(
        Identity,
        id => {
          const trans = this.translations.trackers[id]
          return {
            aggregated: blank(),
            status: object_map(
              Identity,
              k => ({
                ...blank(),
                get width() {
                  return this.done / trackers[id].aggregated.total
                },
              }),
              ["danger", "success", "loading"]
            ),
            get title() {
              return trans ? render_string(trans, this.aggregated) : null
            },
            get width() {
              return 1 / length(trackers)
            },
          }
        },
        tracker_names
      )
      for (const [task_id, task] of Items(this.tasks) as [
        string,
        {
          error: unknown
          finished: boolean
          status: Record<
            string,
            Record<string, { done: number; total: number }>
          >
        },
      ][]) {
        const key = task.error
          ? "danger"
          : task.finished
            ? "success"
            : "loading"
        for (const [id, counters] of Items(task.status) as [
          string,
          Record<string, { done: number; total: number }>,
        ][]) {
          for (const { done, total } of Values(counters)) {
            for (const r of [
              trackers[id].status[key],
              trackers[id].aggregated,
            ]) {
              r.done += done
              r.total += total
              r.task_done += task.finished ? 1 : 0
              r.task_total += 1
            }
          }
        }
      }
      for (const [id, { aggregated }] of Items(trackers)) {
        if (!aggregated.task_total) {
          delete trackers[id]
        }
      }
      return trackers
    },
    translations: () => make_translations("trackers"),
  },
  data() {
    return {
      tasks: {},
    }
  },
  methods: {
    cleanup_tracker(_task_id: string) {
      const to_delete = Keys(
        filter((t, _id) => t.aggregated.is_finished, this.trackers)
      )
      for (const [task_id, t] of Items(this.tasks) as [
        string,
        { status: Record<string, unknown> },
      ][]) {
        for (const id of to_delete) {
          delete_property(t.status, id)
        }
        if (length(t.status) == 0) {
          delete_property(this.tasks, task_id)
        }
      }
    },
    emit(task_id, progress_type, progress_id, { done = null, total = null }) {
      //console.info("task updated", {task_id,progress_type,progress_id,done, total})

      const t = this.start(task_id)
      if (!t.status[progress_type]) {
        t.status[progress_type] = {}
      }
      if (!t.status[progress_type][progress_id]) {
        t.status[progress_type][progress_id] = {}
      }
      const r = t.status[progress_type][progress_id]
      r.done = done || r.done || 0
      r.total = Math.max(total || r.total || 1, r.done)

      if (r.done === r.total) this.finish(task_id)
    },
    finish(task_id, error, timeout = null) {
      // console.info("task finished", { task_id, error })

      const t = this.start(task_id)

      t.finished = true
      t.error = error
      for (const s of Values(t.status)) {
        for (const c of Values(s)) {
          c.done = c.total
        }
      }
      const delay = error ? 5000 : timeout || 2500
      Sleep(delay).then(Partial(this.cleanup_tracker, task_id))

      error
        ? fire_event(document.documentElement, "tracked_error", error)
        : null
    },
    start(task_id) {
      const r = this.tasks[task_id]
      return (
        r ||
        (this.tasks[task_id] = {
          error: null,
          finished: false,
          start_at: UnixTime(),
          status: {},
        })
      )
    },
    track_promise(promise_factory) {
      const task_id = uuid()
      this.start(task_id)

      const promise = Promise.resolve(
        promise_factory(event => this.emit(task_id, event.name, task_id, event))
      )
      SafePromise(promise).then(({ error }) => {
        this.finish(task_id, error)
      })

      return promise
    },
  },
  mounted() {
    RegisterCallbacks({
      push: (task_id, event) => this.emit(task_id, event.name, task_id, event),
      start: task_id => this.start(task_id),
      stop: (task_id, error) => this.finish(task_id, error),
    })
  },
})
